<template>
	<div class="head_container" v-show="showPage">
		
		<!--登录与注册-开始-->
		<el-dialog
		  :title="handleTitle"
		  :visible.sync="handleDialog"
		  :destroy-on-close="false"
		  :close-on-click-modal="false"
		  width="550px">
		  <!--登录-开始-->
		  <div class="login_box" v-if="handleBox == 'login'">
			  <div class="create_user_box">
				<h5>请使用您的电子邮件登录您的帐户。</h5>
				<div class="input_box">
					<div class="item">
						<div class="title">电子邮件</div>
						<div class="e_input">
							<input class="in_txt" v-model="l_email" ref="l_email" type="text" maxlength="50" placeholder="请输入电子邮件地址" />
						</div>
					</div>
					<div class="item">
						<div class="title">登录密码</div>
						<div class="e_input">
							<input class="in_txt" v-model="l_password" ref="l_password" type="password" maxlength="20" placeholder="请输入登录密码" />
						</div>
					</div>
					<div class="error_text" v-if="l_errStatus">{{l_errMessage}}</div>
				</div>
				<div class="btns">					
					<el-button type="primary" :loading="l_btnLoading" style="width: 100%;" @click="loginHandle()">{{l_btnText}}</el-button>
				</div>
				<div class="space_txt">
					<div class="txt">或在下面创建新帐户</div>
				</div>
				<div class="other_box">
					<div class="pub_btn" @click="showHandleBox('sign')">注册新账户</div>
				</div>
			</div>
		  </div>
		  <!--登录-结束-->
		  <!--注册-开始-->
		  <div class="sign_box" v-if="handleBox == 'sign'">
			  <div class="create_user_box">
			  	<h5>请使用您的常用电子邮件注册新帐户。</h5>
			  	<div class="input_box">
			  		<div class="item">
			  			<div class="title">电子邮件</div>
			  			<div class="e_input">
			  				<input class="in_txt" v-model="s_email" ref="s_email" type="text" maxlength="50" placeholder="请输入电子邮件地址" />
			  			</div>
			  		</div>
			  		<div class="item">
			  			<div class="title">登录密码</div>
			  			<div class="e_input">
			  				<input class="in_txt" v-model="s_password" ref="s_password" type="password" maxlength="20" placeholder="请设置登录密码" />
			  			</div>
			  		</div>
			  		<div class="item">
			  			<div class="title">确认密码</div>
			  			<div class="e_input">
			  				<input class="in_txt" v-model="s_repassword" ref="s_repassword" type="password" maxlength="20" placeholder="请再次输入登录密码" />
			  			</div>
			  		</div>
			  		<div class="error_text" v-if="s_errStatus">{{s_errMessage}}</div>
			  	</div>
			  	<div class="btns">
			  		<el-button type="primary" :loading="s_btnLoading" style="width: 100%;" @click="signHandle()">{{s_btnText}}</el-button>
			  	</div>
			  	<div class="space_txt">
			  		<div class="txt">如果您已经注册过账户</div>
			  	</div>
			  	<div class="other_box">
			  		<div class="pub_btn" @click="showHandleBox('login')">立即登录</div>
			  	</div>
			  </div>
		  </div>
		  <!--注册-结束-->
		</el-dialog>
		<!--登录与注册-结束-->
		
		<div class="header">
			<div class="pub_div main_div">
				<div class="basic_div">
					
					<div class="left">
						<div class="logo"><a href="/cn/"></a></div>
						<div class="menu">
							<div class="navigate">旅游产品</div>
							<!--浮动菜单-->
							<div class="fix_box">
								<ul>
									<li><a href="/cn/">首页</a></li>
									<li><a href="/cn/product">旅游套餐</a></li>
									<li><a href="/cn/recreation">景点玩乐</a></li>
									<li><a href="/cn/hotel">酒店</a></li>
									<li><a href="/cn/ticket">景点门票</a></li>
									<!-- <li><a href="#">购物</a></li>
									<li><a href="#">餐饮</a></li> -->
									<!-- <li><a href="/cn/guide">攻略</a></li> -->
								</ul>
							</div>
						</div>
					</div>
					
					<div class="right">						
						
						<div class="contact_box">
							<ul>
								<li class="contact">
									<h4><a href="javascript:void(0)">在线联系</a></h4>
									<div class="qr_box"><img src="@/assets/images/hgh_footer_qrcode.png" />夏威夷檀岛假期<br />Shirley Yang</div>
								</li>
								<li class="telphone">1-808-921-9999</li>
								<li class="email"><a href="mailto:info@hawaiiglobalholiday.com">info@hawaiiglobalholiday.com</a></li>
							</ul>
						</div>
						
						<div class="language_box">
							<a href="/cn" class="selected">简体</a>
							<a href="/tw">繁体</a>
						</div>
						
						<div class="user_div">
							<div class="logined" v-if="loginStatus">
								<div class="content">
									<div class="face"></div>
									<div class="arrow"><a href="/cn/user/index">控制台</a></div>
								</div>
							</div>						
							<div v-else class="nologin" @click="showHandleBox('login')">
								<a href="javascript:void(0)" class="login">登录</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import {
		checkToken,
		userLogout,
		refreshToken,
		userLogin,
		userSign,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	export default {
		name: 'HeaderPage',
		mixins: [mixin],
		data() {
			return {
				qrcodeMenu: false, //二维码菜单
				userMenu: false, //用户菜单
				language: 'cn', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				
				handleTitle: '登录',	//弹窗标题
				handleDialog: false,	//true：显示；false：隐藏
				handleBox: 'login',	//显示内容标识，login：登录表单；sign：注册表单
				
				//登录
				l_email: '',		//账号
				l_password: '',		//密码
				l_errStatus: '',	//错误状态
				l_errMessage: '',	//错误原因
				l_btnLoading: false,	//按钮loading状态
				l_btnText: '立即登录',	//按钮文字
				
				//注册
				s_email: '',		//账号
				s_password: '',		//密码
				s_repassword: '',	//确认密码
				s_errStatus: '',	//错误状态
				s_errMessage: '',	//错误原因
				s_btnLoading: false,	//按钮loading状态
				s_btnText: '立即注册',	//按钮文字
				
				
				showPage: false,
			}
		},
		mounted() {
		},
		created() {
			if(this.isMobile())
			{
				window.location.href = 'https://m.hawaiiglobalholiday.com/pages/cn/index'
			}
			else
			{
				this.showPage = true
			
				// 获取token
				if (this.$storeage.get('token') != null && this.$storeage.get('token') != '') {
					this.token = this.$storeage.get('token')
				
					this.checkTokenValid()
				}
				else
				{
					this.$emit('custom-event','','')
				}
			}
		},
		methods: {
			//检查token是否有效
			async checkTokenValid() {
				const { data: res } = await checkToken(this.token, this.terminal)
				if (res.errcode === 0) {
					this.loginStatus = true
					
					//向父级传值
					this.$emit('custom-event',this.token)
					
					//检查token还有多久过期
					this.tokenExpireCheck()
				} else {					
					//无效，清除token
					this.$storeage.remove('token')
					this.$storeage.remove('expire')
					this.token = null
					this.loginStatus = false
					
					//向父级传值
					this.$emit('custom-event','')
				}
			},
			// 计算token还有多长时间过期
			tokenExpireCheck() {
				//判断当前token距失效时间还有多久
				if (this.$storeage.get('expire') == null || this.$storeage.get('expire') == '') {
					return
				}
				if (this.$storeage.get('token') == null || this.$storeage.get('token') == '') {
					return
				}
				
				let expire = this.$storeage.get('expire')
				let nowTime = moment().format('YYYY-MM-DD HH:mm:ss')
				let seconds = Math.abs(moment(nowTime).diff(moment(expire))) / 1000	//相差秒数
				
				if(moment(nowTime) < moment(expire))
				{
					//未过期
					if(seconds < 7200)	//2小时
					{
						this.refreshToken()
					}
				}
			},
			// 刷新Token
			async refreshToken()
			{
				const { data: res } = await refreshToken(this.token, 'pc')
				if (res.errcode === 0) {
					// 更新客户端Token
					this.$storeage.set('token',res.data.Token)
					this.$storeage.set('expire',res.data.ExpireTime)
					
					this.token = res.data.Token
					this.$emit('custom-event',this.token)
				}
			},
			//二维码菜单显示/关闭
			qrcodeMenuShow() {
				this.userMenu = false
				if (this.qrcodeMenu) {
					this.qrcodeMenu = false
				} else {
					this.qrcodeMenu = true
				}
			},
			//二维码菜单关闭
			qrcodeMenuHide() {
				this.qrcodeMenu = false
			},
			// //用户菜单显示/关闭
			// userMenuShow() {
			// 	this.qrcodeMenu = false
			// 	if (this.userMenu) {
			// 		this.userMenu = false
			// 	} else {
			// 		this.userMenu = true
			// 	}
			// },
			// //用户菜单关闭
			// userMenuHide() {
			// 	this.userMenu = false
			// },
			//跳转至
			toPage(url) {
				this.$router.push({
					path: url
				})
			},
			//链接至
			linkTo(url) {
				window.location.href = url
			},
			// 退出登录
			async userLogout()
			{
				let params={
					Token: this.token,
					Terminal: this.terminal,
				}
				
				const { data: res } = await userLogout(params)
				if (res.errcode === 0) {
					this.$storeage.remove('token')
					this.$storeage.remove('expire')
					this.token = null
					this.loginStatus = false
					this.toPage('/cn/')
				} else {					
					this.$message.error(res.errmsg);
				}
			},
			//切换弹出层内容
			showHandleBox (tag)
			{
				this.resetLoginSignElement()
				this.handleDialog = true
				if(tag == 'login')
				{
					this.handleTitle='登录'
					this.handleBox='login'
					
					//注册
					this.s_email=''		//账号
					this.s_password=''		//密码
					this.s_repassword=''	//确认密码
					this.s_errStatus=''	//错误状态
					this.s_errMessage=''	//错误原因
					this.s_btnLoading=false	//按钮loading状态
					this.s_btnText='立即注册'	//按钮文字
				}
				else if(tag == 'sign')
				{
					this.handleTitle='注册新账户'
					this.handleBox='sign'
					
					//登录
					this.l_email=''		//账号
					this.l_password=''		//密码
					this.l_errStatus=''	//错误状态
					this.l_errMessage=''	//错误原因
					this.l_btnLoading=false	//按钮loading状态
					this.l_btnText='立即登录'	//按钮文字
				}
			},
			//重置登录与注册表单
			resetLoginSignElement() {
				//登录
				this.l_email=''		//账号
				this.l_password=''		//密码
				this.l_errStatus=''	//错误状态
				this.l_errMessage=''	//错误原因
				this.l_btnLoading=false	//按钮loading状态
				this.l_btnText='立即登录'	//按钮文字
				
				//注册
				this.s_email=''		//账号
				this.s_password=''		//密码
				this.s_repassword=''	//确认密码
				this.s_errStatus=''	//错误状态
				this.s_errMessage=''	//错误原因
				this.s_btnLoading=false	//按钮loading状态
				this.s_btnText='立即注册'	//按钮文字
			},
			//登录
			async loginHandle()
			{
				if(this.l_btnLoading)
				{
					return
				}
				
				if(this.l_email =='')
				{
					this.l_errStatus = true
					this.l_errMessage = '请输入电子邮件地址'
					this.$refs.l_email.focus()
					return
				}
				const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				if (!emailPattern.test(this.l_email)) {
					this.l_errStatus = true
					this.l_errMessage = '电子邮件格式错误'
					this.$refs.l_email.focus()
					return
				}
					  
				if(this.l_password =='')
				{
					this.l_errStatus = true
					this.l_errMessage = '请输入登录密码'
					this.$refs.l_password.focus()
					return
				}
				if(this.l_password.length < 6)
				{
					this.l_errStatus = true
					this.l_errMessage = '密码长度不得小于6个字符'
					this.$refs.l_password.focus()
					return
				}
				
				this.l_errStatus = false
				this.l_errMessage = ''
				
				this.l_btnLoading = true
				this.l_btnTxt = "登录中，请稍候..."
				this.fullscreenLoading = true
				
				let params={
					Email: this.l_email,
					Password: this.l_password,
					Terminal: this.terminal
				}
				const { data: res } = await userLogin(params)
				if (res.errcode === 0) {
					//处理登录后逻辑
					this.$storeage.set('token',res.data.Token)
					this.$storeage.set('expire',res.data.ExpireTime)
					
					//重置弹窗表单内容
					this.resetLoginSignElement()
					
					//关闭弹窗
					this.handleDialog = false
					this.loginStatus =  true
					this.token = res.data.Token
					
					//向父级传值
					this.$emit('custom-event',this.token)
					
				} else {
					this.l_btnLoading = false
					this.l_btnTxt = "登录"
					this.fullscreenLoading = false
					this.$message.error(res.errmsg);
				}
			},
			// 注册
			async signHandle()
			{
				if(this.s_btnLoading)
				{
					return
				}
				
				if(this.s_email =='')
				{
					this.s_errStatus = true
					this.s_errMessage = '请输入电子邮件地址'
					this.$refs.s_email.focus()
					return
				}
				const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				if (!emailPattern.test(this.s_email)) {
					this.s_errStatus = true
					this.s_errMessage = '电子邮件格式错误'
					this.$refs.s_email.focus()
					return
				}
					  
				if(this.s_password =='')
				{
					this.s_errStatus = true
					this.s_errMessage = '请输入登录密码'
					this.$refs.s_password.focus()
					return
				}
				if(this.s_password.length < 6)
				{
					this.s_errStatus = true
					this.s_errMessage = '密码长度不得小于6个字符'
					this.$refs.s_password.focus()
					return
				}
				
				if(this.s_repassword == '')
				{
					this.s_errStatus = true
					this.s_errMessage = '请再次输入登录密码'
					this.$refs.s_repassword.focus()
					return
				}
				if(this.s_repassword != this.s_password)
				{
					this.s_errStatus = true
					this.s_errMessage = '两次输入密码的不一致，请重新输入'
					this.$refs.s_repassword.focus()
					return
				}
				
				this.s_errStatus = false
				this.s_errMessage = ''
				
				this.s_btnLoading = true
				this.s_btnTxt = "处理中，请稍候..."
				this.fullscreenLoading = true
				
				let params = {
					Language: this.language,
					Email: this.s_email,
					Password: this.s_password,
				}
				const { data: res } = await userSign(params)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.$message.success('恭喜您，注册成功！');
					this.resetLoginSignElement()
					this.handleTitle='登录并开始探索'
					this.handleBox = 'login'
					
				} else {
					this.s_btnLoading = false
					this.s_btnTxt = "注册"
					this.fullscreenLoading = false
					this.$message.error(res.errmsg);
				}
			},
		},
	}
</script>

<style lang="less" scoped>
	.head_container {
		width: 100%;
	}
	.header {
		width: 100%;
		height: 80px;
		padding: 10px 0;
		box-sizing: border-box;
		background: #fff;
		box-shadow: 1px 1px 5px #eee;

		.main_div {
			position: relative;
			height: 62px;

			.basic_div {
				position: relative;
				display: flex;
				justify-content: space-between;
				align-items: center;

				.left {
					display: flex;
					justify-content: left;

					.logo {
						width: 213px;
						height: 60px;
						background-image: url(@/assets/images/hgh_logo.png);
						background-repeat: no-repeat;
						background-size: auto 100%;

						a {
							height: 60px;
							display: block;
						}
					}

					.menu {
						margin: 10px 0 0 30px;
						position: relative;
						
						.navigate {
							height: 40px;
							box-sizing: border-box;
							border-radius: 20px;
							line-height: 40px;
							background-image: url(../assets/images/hgh_menu.png);
							background-size: 28px 28px;
							background-repeat: no-repeat;
							background-position: right 8px center;
							font-size: 15px;
							padding: 0 35px 0 18px;
							border: #A6A6A6 solid 1px;
							cursor: pointer;
							background-color: #fff;
							-webkit-transition: all .3s ease;
						}
						.navigate:hover {
							color: #3D7856;
							border: #3D7856 solid 1px;
						}
						
						.fix_box {
							display: none;
							position: absolute;
							z-index: 1000;
							top: 40px;
							left: 0;
							width: 220px;
							box-sizing: border-box;
							background-color: #fff;
							padding: 10px;
							border-radius: 10px;
							box-shadow: 1px 1px 5px #888;
							-webkit-transition: all .3s ease;
							
							ul {
								li {
									font-size: 15px;
									
									a {
										display: block;
										height: 38px;
										line-height: 38px;
										border: #fff solid 2px;
										padding: 0 10px;
										border-radius: 5px;
										-webkit-transition: all .3s ease;
									}
									a:hover {
										border: #3D7856 solid 2px;
									}
								}
							}
						}
					}
					.menu:hover {
						.fix_box {
							display: block;
						}
					}
				}
				
				

				.right {
					display: flex;
					justify-content: right;
					align-items: center;
					
					.contact_box {
						margin-right: 40px;
						
						ul,li {
							list-style: none;
						}
						ul {
							display: flex;
							
							li {
								margin-left: 30px;
								font-size: 14px;
								background-position: left center;
								background-repeat: no-repeat;
								background-size: 32px 32px;
								white-space: nowrap;
								padding-left: 32px;
							}
							li.contact {
								margin-left: 0;
								background-image: url(@/assets/images/hgh_contact.png);
								position: relative;
								
								h4 {
									font-size: 14px;
									font-weight: 400;
								}
								
								.qr_box {
									display: none;
									position: absolute;
									z-index: 1000;
									top: 30px;
									left: 0;
									width: 160px;
									box-sizing: border-box;
									background-color: #fff;
									padding: 8px;
									border-radius: 10px;
									text-align: center;
									font-size: 13px;
									line-height: 120%;
									box-shadow: 1px 1px 5px #888;
									
									img {
										width: 100%;
										display: block;
										margin-bottom: 6px;
									}
								}
							}
							li.contact:hover {
								.qr_box {
									display: block;
								}
							}
							li.telphone {
								background-image: url(@/assets/images/hgh_telphone.png);
							}
							li.email {
								background-image: url(@/assets/images/hgh_email.png);
							}
						}
					}
					
					/*语言版本*/
					.language_box {
						height: 30px;
						line-height: 30px;
						margin-right: 40px;
						
						a {
							display: inline-block;
							font-size: 14px;
							white-space: nowrap;
							margin: 0 6px;
						}
						a.selected {
							font-size: 15px;
							font-weight: 500;
							color: #3D7856;
							text-decoration: underline;
						}
					}


					.user_div {
						height: 40px;
						border-radius: 20px;
						border: #A6A6A6 solid 1px;
						background: #fff;
						font-size: 15px;
						line-height: 40px;
						-webkit-transition: all .3s ease;
						cursor: pointer;

						.logined {
							position: relative;
							padding: 0 18px 0 10px;

							.content {
								display: flex;
								justify-content: space-between;
								align-items: center;
								cursor: pointer;

								.face {
									width: 32px;
									height: 32px;
									background-repeat: no-repeat;
									background-image: url(@/assets/images/hgh_face.png);
									background-size: 32px 32px;
									background-position: center;
									cursor: pointer;
								}
							}
						}

						.nologin {							
							display: flex;
							align-items: center;
							padding: 0 10px;

							a {
								height: 40px;
								line-height: 40px;
								text-decoration: none;
								display: block;
								margin: 0 12px;
							}
						}
					}
					.user_div:hover {
						border: #3D7856 solid 1px;
					}
				}

			}

			/deep/ .el-tabs__item {
				font-size: 16px;
				font-weight: 400;
				color: #000;
			}

			/deep/ .el-tabs__item.is-active {
				font-weight: 500;
			}

			/deep/ .el-tabs__active-bar {
				background-color: #000;
			}

			/deep/ .el-tabs__nav-wrap::after {
				height: 1px;
			}
		}
	}
	
	/*用户注册与登录*/
	.create_user_box {
		margin: 0 auto 0 auto;
		box-sizing: border-box;
	
		h1 {
			margin-top: 0;
			font-size: 28px;
			font-weight: 500;
			text-align: center;
			color: #111;
		}
	
		h5 {
			margin-top: 0;
			font-size: 13px;
			font-weight: 400;
			text-align: left;
			color: #999;
		}
	
		.input_box {
			margin-top: 40px;
	
			.item {
				margin-top: 20px;
				display: flex;
				justify-content: space-between;
				height: 52px;
				box-sizing: border-box;
				border: #c4c4c4 solid 1px;
				border-radius: 8px;
				font-size: 15px;
				line-height: 26px;
	
				.title {
					width: 15%;
					padding: 12px 20px;
					color: #666;
				}
	
				.e_input {
					width: 83%;
					padding: 6px 12px 6px 0;
	
					.in_txt {
						width: 100%;
						height: 38px;
						line-height: 38px;
						padding: 0;
						border: 0;
						outline: 0;
						font-size: 16px;
					}
				}
	
				::placeholder {
					color: #aaa;
				}
			}
		}
	
		.btns {
			margin-top: 30px;
	
			.pub_btn {
				border-radius: 8px;
			}
		}
	
		.space_txt {
			position: relative;
			margin-top: 30px;
			height: 30px;
			background-image: url(@/assets/images/icons/space_line.png);
			background-position: center;
			background-repeat: no-repeat;
			text-align: center;
	
			.txt {
				margin: 0 auto;
				display: inline-block;
				padding: 0 30px;
				background: #fff;
				color: #333;
				text-align: center;
				font-size: 13px;
				line-height: 30px;
			}
		}
	
		.other_box {
			margin-top: 20px;
	
			.pub_btn {
				margin: 0 auto;
				width: 120px;
				border-radius: 8px;
				background-color: #fff;
				border: #3D7856 solid 1px;
				color: #3D7856;
			}
	
			.pub_btn:hover {
				background-color: #000;
				border: #000 solid 1px;
				color: #fff;
			}
		}
	}
	
	.el-button--primary {
		font-family: "PingFang SC", sans-serif, Helvetica, Arial;
		font-size: 15px;
		font-weight: 400;
		height: 42px;
		border: 0;
		border-radius: 8px;
		-webkit-transition: all .3s ease;
	}
	.el-button--primary:focus {
		background-color: #3D7856;
	}
	.el-button--primary:hover {
		background-color: #000;
	}
	
	/deep/ .el-dialog {
		border-radius: 8px;
	}
	/deep/ .el-dialog__header {
		padding: 30px 30px 10px 30px;
	}
</style>